// Authors: Ben Croker
// Icon: material-symbols:bigtop-updates
// Slug: Runs an expression whenever a signal changes
// Description: This attribute runs an expression whenever a signal changes.

import {
  type AttributePlugin,
  DATASTAR_SIGNAL_EVENT,
  type DatastarSignalEvent,
  PluginType,
  Requirement,
} from '../../../engine/types'
import { modifyCasing } from '../../../utils/text'
import { modifyTiming } from '../../../utils/timing'
import { pathMatchesPattern } from '../../../utils/paths'
import { modifyViewTransition } from '../../../utils/view-transtions'

export const OnSignalChange: AttributePlugin = {
  type: PluginType.Attribute,
  name: 'onSignalChange',
  valReq: Requirement.Must,
  argNames: ['evt'],
  onLoad: ({ key, mods, genRX, evalRX }) => {
    const { dm, deps, rxFn } = genRX()
    let callback = (evt: Event) => evalRX(rxFn, dm, deps, evt)
    callback = modifyTiming(callback, mods)
    callback = modifyViewTransition(callback, mods)

    const signalFn = (event: CustomEvent<DatastarSignalEvent>) => {
      if (key !== '') {
        const pattern = modifyCasing(key, mods)
        const { added, removed, updated } = event.detail
        if (
          ![...added, ...removed, ...updated].some((path) =>
            pathMatchesPattern(path, pattern),
          )
        ) {
          return
        }
      }
      callback(event)
    }

    document.addEventListener(DATASTAR_SIGNAL_EVENT, signalFn)

    return () => {
      document.removeEventListener(DATASTAR_SIGNAL_EVENT, signalFn)
    }
  },
}
